import {
  EDIT_FIRST_NAME_REGISTER, EDIT_LAST_NAME_REGISTER, EDIT_SURNAME_REGISTER,
  EDIT_EMAIL_REGISTER, EDIT_FIRST_PASSWORD, EDIT_SECOND_PASSWORD, RESET_REGISTER_FORM,
  SWITCH_CHECKBOX_PERMISSION, EDIT_PHONE_REGISTER
} from "../actions/register_form_actions";


const initialState = {
  first_name: '',
  last_name: '',
  surname: '',
  phone: '',
  email: '',
  first_password: '',
  second_password: '',
  checkbox_permission: false
}

export const registerFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_FIRST_NAME_REGISTER: {
      return {
        ...state,
        first_name: action.first_name
      }
    }
    case EDIT_LAST_NAME_REGISTER: {
      return {
        ...state,
        last_name: action.last_name
      }
    }
    case EDIT_SURNAME_REGISTER: {
      return {
        ...state,
        surname: action.surname
      }
    }
    case EDIT_PHONE_REGISTER: {
      return {
        ...state,
        phone: action.phone
      }
    }
    case EDIT_EMAIL_REGISTER: {
      return {
        ...state,
        email: action.email
      }
    }
    case EDIT_FIRST_PASSWORD: {
      return {
        ...state,
        first_password: action.first_password
      }
    }
    case EDIT_SECOND_PASSWORD: {
      return {
        ...state,
        second_password: action.second_password
      }
    }
    case SWITCH_CHECKBOX_PERMISSION: {
      return {
        ...state,
        checkbox_permission: action.checkbox_permission
      }
    }
    case RESET_REGISTER_FORM: {
      return {
        ...state,
        first_name: '',
        last_name: '',
        surname: '',
        phone: '',
        email: '',
        first_password: '',
        second_password: '',
        checkbox_permission: false
      }
    }
    default: return state;
  }
}
